import { render, staticRenderFns } from "./EventWrapper.vue?vue&type=template&id=84abf514&scoped=true"
import script from "./EventWrapper.vue?vue&type=script&lang=js"
export * from "./EventWrapper.vue?vue&type=script&lang=js"
import style0 from "./EventWrapper.vue?vue&type=style&index=0&id=84abf514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84abf514",
  null
  
)

export default component.exports